import { Container, Row, Col, Navbar } from "react-bootstrap";
import { SiGithub, SiLinkedin, SiInstagram } from "react-icons/si";
import Logo from "./Logo";
import Companies from "./Companies";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center ">
          <Companies />
          {/* <MailchimpForm /> */}
          <Col>
            <Navbar.Brand href="/">
              <Logo />
            </Navbar.Brand>
          </Col>

          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/eric-ramos-85b08a1b8/"
                target="_blank"
                rel="noreferrer"
              >
                <SiLinkedin color="white" />
              </a>
              <a
                href="https://github.com/e-ramos18"
                target="_blank"
                rel="noreferrer"
              >
                <SiGithub color="white" />
              </a>
              <a
                href="https://www.instagram.com/__im_eric/"
                target="_blank"
                rel="noreferrer"
              >
                <SiInstagram color="white" />
              </a>
            </div>
            <p>&copy; {new Date().getFullYear()} ER Dev All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
